const headerBanner = document.querySelector('.header-banner');
const startDateString = 'July 4, 2023 14:40:00';
const endDateString = 'October 22, 2024 00:00:00';

if (headerBanner) {
    var headerBannerCounter = headerBanner.querySelector('.header-banner-counter');
    var actualDate = new Date();
    var startDate = new Date(startDateString);
    var endDate = new Date(endDateString);

    if (actualDate < endDate && (actualDate > startDate || actualDate === startDate)) {
        headerBanner.classList.remove('hidden');

        // if counter exists in HTML template then starts counter
        if (headerBannerCounter) {
            countdown();
        }
    }

    if (actualDate === endDate || actualDate > endDate) {
        headerBanner.classList.add('hidden');
    }
}

// Counter function for prepared counter
function countdown() {
    var now = new Date();
    var eventDate = new Date(endDateString);

    var currentTime = now.getTime();
    var eventTime = eventDate.getTime();

    var remTime = eventTime - currentTime;

    var seconds = Math.floor(remTime / 1000);
    var minutes = Math.floor(seconds / 60);
    var hours = Math.floor(minutes / 60);
    var days = Math.floor(hours / 24);

    hours %= 24;
    minutes %= 60;
    seconds %= 60;

    hours = (hours < 10) ? '0' + hours : hours;
    minutes = (minutes < 10) ? '0' + minutes : minutes;
    seconds = (seconds < 10) ? '0' + seconds : seconds;

    headerBannerCounter.textContent = days + ' days ' + hours + ' hours ' + minutes + ' minutes ' + seconds + ' seconds ';

    setTimeout(countdown, 1000);
}